import supportersMutations from "./supporters.mutation";
import supportersStates from "./supporters.state";
import supportersActions from "./supporters.action";
import supportersGetters from "./supporters.getters";

export default {
  mutations: supportersMutations,
  state: supportersStates,
  actions: supportersActions,
  getters: supportersGetters
};
